import * as React from "react";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Link } from "components/common";
import { Alert } from "components/bootstrap";
import usePermissions from "hooks/usePermissions";
import DocsHelper from "util/DocsHelper";
import useUsageWarningAcknowledgementMutation from "license/notifications/hooks/useUsageWarningAcknowledgementMutation";
import LicensesRoutes from "license/Routes";
const StyledAlert = styled(Alert)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.md};
  `
);
const LicenseUsageWarningNotification = ({ remainingVolume }) => {
  const { isPermitted } = usePermissions();
  const { t } = useTranslation("enterprise_license");
  const productName = useProductName();
  const { acknowledgeNotifcation } = useUsageWarningAcknowledgementMutation();
  const onDismiss = () => {
    acknowledgeNotifcation();
  };
  const bsStyle = remainingVolume <= 40 ? "warning" : "info";
  if (remainingVolume === void 0) return null;
  return /* @__PURE__ */ React.createElement(
    StyledAlert,
    {
      bsStyle,
      title: t("license.notifications.usage_title", { productName }),
      onDismiss
    },
    /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "license.notifications.usage_warning_body",
        values: { productName, remaining: remainingVolume },
        components: {
          licenseLink: isPermitted("licenses:create") ? /* @__PURE__ */ React.createElement(Link, { to: LicensesRoutes.LIST }) : /* @__PURE__ */ React.createElement(React.Fragment, null)
        }
      }
    ), " ", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "license.notifications.usage_warning_details",
        values: { productName },
        components: { docsLink: /* @__PURE__ */ React.createElement(Link, { to: DocsHelper.toString(DocsHelper.PAGES.LICENSE_MANAGEMENT) }) }
      }
    )))
  );
};
export default LicenseUsageWarningNotification;
